import { render, staticRenderFns } from "./PartnershipsModal.vue?vue&type=template&id=bc6a2956&scoped=true"
import script from "./PartnershipsModal.vue?vue&type=script&lang=js"
export * from "./PartnershipsModal.vue?vue&type=script&lang=js"
import style0 from "./PartnershipsModal.vue?vue&type=style&index=0&id=bc6a2956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6a2956",
  null
  
)

export default component.exports